import './BackDrop.css';
import React from 'react';
import Backdrop from '@mui/material/Backdrop';

import Logo from '../../../logo.svg';

export default function BackDrop(props) {
  const { open } = props;
  return (
    <div className="back-drop">
      <Backdrop open={open}>
        <img className="logo" width="70px" src={Logo} />
        <span className="loader"></span>
        <span className="loader-inner"></span>
      </Backdrop>
    </div>
  );
}
